import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import de from "@/assets/locales/de.json";
import en from "@/assets/locales/en.json";

const resources = {
  de: { translation: de },
  en: { translation: en }
};

const savedLanguage = localStorage.getItem("language") || "de";
document.documentElement.lang = savedLanguage;

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage,
  fallbackLng: "de",
  interpolation: {
    escapeValue: false
  }
});

export const changeLanguage = (lng: string) => {
  localStorage.setItem("language", lng);
  document.documentElement.lang = lng;
  i18n.changeLanguage(lng);
};

export const getCurrentLanguage = () => i18n.language;

export default i18n;
